import { Grid } from '@mui/material'
import { TextFieldWithLabel } from '../../Components/TextField'
import { SelectWithLabel } from '../../Components/SelectWithLabel'
import { sendGet } from '../../hooks/use-fetch'
import { useEffect, useState } from 'react'
import { type lookup } from '../../core/types'

export interface ReferralSearchCriteria {
  schoolYearId: number
  childName: string
  facility: string
  serviceID: number
  serviceProviderId: number
}

export function ReferralSearch (props: { current: ReferralSearchCriteria, onChange: (newSearch: ReferralSearchCriteria) => void, addButton?: JSX.Element, schoolYearOptions: lookup[] }): JSX.Element {
  const [facilityOptions, setFacilityOptions] = useState([])
  const handleChange = (e: any): void => {
    let value = e.target.value
    if (e.target.name === 'schoolYearId') {
      value = Number(e.target.value) // Gah!!!
    }
    props.onChange({ ...props.current, [e.target.name]: value })
  }

  useEffect(() => {
    const fetchData = async (): Promise<void> => {
      const { response } = await sendGet(`/ReferralSearch/GetFacilityOptions?serviceID=${props.current.serviceID}&serviceProviderId=${props.current.serviceProviderId}`, {})
      if (response !== undefined && response.length > 0) {
        response.push({ id: 'showAll', name: 'Show All' })
        setFacilityOptions(response)
      }
    }
    void fetchData()
  }, [props.current.serviceID])

  return (<Grid item sm={8} md={10} lg={11} container spacing={1} rowGap={0} rowSpacing={-1} >
    <Grid item>
      <SelectWithLabel
        name="schoolYearId"
        label="School Year"
        width='200px'
        value={props.current.schoolYearId}
        options={props.schoolYearOptions}
        onChange={handleChange}
      />
    </Grid>
    <Grid item>
      <TextFieldWithLabel
        label='Child Name'
        onChange={handleChange}
        name='childName'
        maxWidth='205px'
        value={props.current.childName}
        data-testid="name-search"
      />
    </Grid>
    <Grid item>
      <SelectWithLabel
        name="facility"
        label="Facility"
        width='200px'
        value={props.current.facility}
        options={facilityOptions}
        onChange={handleChange}
      />
    </Grid>
    <Grid item sx={{ alignItems: 'center', display: 'flex' }}>
      {props.addButton}
    </Grid>
  </Grid>
  )
}
